import React, { useState } from 'react'
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";

const stripePromise = loadStripe(
  'pk_live_51OkUA1FukknjXIe1tOSqM6J6uYLPCnytkNHwmc3e8IGGdCVMnyuL9U9Ul3cddQPX4pwd7Sy92woDihSEBUU1GE2f00oRy6oi1k'
);

var CustomHttp = require('../CustomHttp');

function CheckoutForm({ payload, onSuccess, onClose }) {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);

  const handleCardChange = (event) => {
    console.log(event);
    if (event.error) {
      setErrorMsg(event.error.message);
    } else {
      setErrorMsg(null);
    }
    setCardComplete(event.complete); // ✅ TRUE only if card fully valid
  };

  const handlePayment = async () => {
    if (!stripe || !elements) {
      toast.error("Stripe not loaded. Please refresh page.");
      return;
    }

    if (!cardComplete) {
      setErrorMsg("Please enter valid card details.");
      return;
    }

    setErrorMsg(null);
    setLoading(true);

    try {
        /* -------------------- 1️⃣ CREATE SUBSCRIPTION INTENT -------------------- */
        const res = await CustomHttp.postRequest(
            "/create-subscription-intent",
            payload
        );
        console.log(res);
        if (!res || res.status === false) {
            const msg =
            Array.isArray(res?.message)
                ? res.message[0]
                : res?.message || "Unable to start payment. Please check details.";

            setErrorMsg(msg);
            setLoading(false);
            return;
        }

        /* ---------------- TRIAL FLOW ---------------- */
        // payload.stripe_customer_id = res.stripe_customer_id;
        // payload.stripe_subscription_id = res.subscription_id;
        payload.hasTrial = res.hasTrial;

        if (!res.clientSecret) {
            setErrorMsg("Payment initialization failed. Please try again.");
            setLoading(false);
            return;
        }
        /* -------------------- 2️⃣ CONFIRM CARD PAYMENT -------------------- */
        let result = null;
        if (res.hasTrial) {
            result = await stripe.confirmCardSetup(res.clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                    billing_details: {
                        name: `${payload.first_name} ${payload.last_name}`,
                        email: payload.email,
                    },
                },
            });
            if (result.error) {
                setErrorMsg(result.error.message);
                setLoading(false);
                return;
            }
            const setupIntent = result?.setupIntent || null;
            const paymentMethodId = setupIntent?.payment_method || null;
            payload.paymentMethodId = paymentMethodId;
        } else {
            result = await stripe.confirmCardPayment(res.clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                    billing_details: {
                        name: `${payload.first_name} ${payload.last_name}`,
                        email: payload.email,
                    },
                },
            });
            if (result.error) {
                setErrorMsg(result.error.message);
                setLoading(false);
                return;
            }
            const paymentIntent = result?.paymentIntent || null;
            const paymentMethodId = paymentIntent?.payment_method || null;
            payload.paymentMethodId = paymentMethodId;
        }
        console.log(result);
        // if (result.error) {
        //     setErrorMsg(result.error.message);
        //     setLoading(false);
        //     return;
        // }
        console.log("payload:", payload);
        /* -------------------- 3️⃣ PAYMENT SUCCESS -------------------- */
        toast.success("Payment successful! Finalizing registration...");
        setLoading(false);
        onSuccess(payload);
    } catch (err) {
      console.error("Stripe error:", err);
      setErrorMsg("Server error. Please try again later.");
      setLoading(false);
    }
  };

  return (
    <>
      <div className="my-10">
        <CardElement
            onChange={handleCardChange}
            options={{
                hidePostalCode: true,
                style: {
                base: {
                    fontSize: "16px",
                },
                },
            }}
        />
      </div>

      {errorMsg && (
        <div className="alert alert-danger mb-3">
          {errorMsg}
        </div>
      )}

      <button
        className="btn btn-primary w-100"
        disabled={loading || !cardComplete}
        onClick={handlePayment}
      >
        {loading ? "Processing..." : "Pay & Register"}
      </button>
    </>
  );
}

export default function StripePaymentModal({ show, close, save, payload }) {
  if (!show) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h4 className="m-0">Enter Payment Details</h4>
          <button onClick={close} style={styles.closeBtn} disabled={false}>
            ✕
          </button>
        </div>

        <Elements stripe={stripePromise}>
          <CheckoutForm
            payload={payload}
            onSuccess={(payload) => {
              save(payload);
              window.location.href = "/login";
            }}
            onClose={close}
          />
        </Elements>
      </div>
    </div>
  );
}

/* -------------------- STYLES -------------------- */
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.6)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  modal: {
    background: "#fff",
    borderRadius: "8px",
    width: "420px",
    padding: "20px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px"
  },
  closeBtn: {
    background: "transparent",
    border: "none",
    fontSize: "18px",
    cursor: "pointer"
  }
};
